<script lang="ts">
  export let src: string;
  export let alt: string;

  export let width: string = "24px";
  export let height: string = "24px";
</script>

<button on:click style:width style:height>
  <img style:width style:height {src} {alt} />
</button>

<style lang="scss">
  @import "src/lib/styles/variables";

  button {
    margin: 0;
    padding: 0;
    border: 0;
    cursor: pointer;
    background-color: $color-white;
  }
</style>
